/* eslint-disable  react/prop-types */

import React from 'react';

const DownloadIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="download-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82575 6.15232C5.45114 5.7465 4.81848 5.72119 4.41266 6.0958C4.00684 6.4704 3.98153 7.10306 4.35614 7.50888L7.26523 10.6604C7.45454 10.8655 7.72094 10.9821 8.00003 10.9821C8.27913 10.9821 8.54553 10.8655 8.73484 10.6604L11.6439 7.50888C12.0185 7.10306 11.9932 6.4704 11.5874 6.0958C11.1816 5.72119 10.5489 5.7465 10.1743 6.15232L9.00003 7.42447V1.98212C9.00003 1.42983 8.55232 0.982117 8.00003 0.982117C7.44775 0.982117 7.00003 1.42983 7.00003 1.98212V7.42447L5.82575 6.15232ZM2 9C2 8.44772 1.55228 8 1 8C0.447715 8 0 8.44772 0 9V13C0 14.1046 0.895431 15 2 15H14C15.1046 15 16 14.1046 16 13V9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9V13H2V9Z"
      fill="#00AED9"
    />
  </svg>
);

export default DownloadIcon;
